module.exports = __webpack_public_path__ + "img/second-conversation-on-device.9b7409b6.jpg";